var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2C3421;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1047.7,1029.3c-3.3,7.9-10.9,13-19.5,13H53.6c-11.6,0-21.1-9.4-21.1-21.1V66.5c0-8.5,5.1-16.2,13-19.5 c7.9-3.3,16.9-1.5,23,4.6l520.6,520.6c8.2,8.2,8.2,21.6,0,29.8c-8.2,8.2-21.6,8.2-29.8,0L74.7,117.4v189.1h36 c11.6,0,21.1,9.4,21.1,21.1c0,11.6-9.4,21.1-21.1,21.1h-36v210.8h36c11.6,0,21.1,9.4,21.1,21.1c0,11.6-9.4,21.1-21.1,21.1h-36v214.9 h36c11.6,0,21.1,9.4,21.1,21.1c0,11.6-9.4,21.1-21.1,21.1h-36v141.4h902.7l-25.4-25.4c-8.2-8.2-8.2-21.6,0-29.8 c8.2-8.2,21.6-8.2,29.8,0l61.4,61.4C1049.2,1012.3,1051,1021.4,1047.7,1029.3z M267.4,559.5c-11.6,0-21.1,9.4-21.1,21.1v230.1 c0,11.6,9.4,21.1,21.1,21.1h228.5c11.6,0,21.1-9.4,21.1-21.1s-9.4-21.1-21.1-21.1H288.5v-209C288.5,568.9,279,559.5,267.4,559.5z  M655.9,895.5V275.4c0-4.1,1.2-8,3.4-11.4l94.7-146.9c3.9-6,10.5-9.6,17.6-9.7c0,0,0.1,0,0.1,0c7.1,0,13.7,3.6,17.6,9.5l94.7,143.6 c2.3,3.4,3.5,7.5,3.5,11.6v623.4c0,11.6-9.4,21.1-21.1,21.1H677C665.4,916.6,655.9,907.2,655.9,895.5z M845.2,874.5v-90H698.1v90 H845.2z M698.1,281.6v460.7h147.2V278.4l-73.4-111.3L698.1,281.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDs);
export default __webpack_public_path__ + "static/media/ds.f6d99606e5b75c06c9ab58d28a4eaef6.svg";
export { ForwardRef as ReactComponent };